import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { SearchBox } from 'fw/forms';
import { SetupSearch } from 'areas/shared/pages/setup';
import * as API from 'modules/app/API'

class Search extends SetupSearch {

    initialForm() {
        return {
            searchText: "",
            statusFilter: true,
            roleId: null
        };
    }

    ready = () => {
        this.focusControl && this.focusControl.focus();
    }

    searchLoader = () => {
        return {
            url: API.Search.url('/suggest'),
            params: {
                type: 'naicsCode'
            }
        }
    }

    renderForm() {
        return (
            <Row>
                <Col md={4}>
                    <SearchBox
                        name="code"
                        label="code"
                        placeholder="Code"
                        loader={this.searchLoader}
                        ref={(c) => { this.focusControl = c }} />
                </Col>
                <Col md={4}>
                    <SearchBox
                        name="description"
                        label="description"
                        placeholder="Description"
                        loader={this.searchLoader}
                        ref={(c) => { this.focusControl = c }} />
                </Col>
            </Row>
        )
    }
}

export default Search;



// WEBPACK FOOTER //
// ./src/areas/admin/naicsCodeSetup/Search.js